'use client';

import React, { useState } from "react";
import { LoginForm } from "./LoginForm";
import { SignupFlow } from "./SignupFlow";
import { ForgotPinFlow } from "./ForgotPinFlow";
import { JoinFlow } from "./JoinFlow";

export const AuthScreen = ({ onAuthed, initialMode = "login", onHome, plan = null }) => {
  const [mode, setMode] = useState(initialMode);
  const [notice, setNotice] = useState("");

  const go = (m) => {
    setNotice("");
    setMode(m);
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-zinc-950 px-4 py-10"
      style={{ fontFamily: "'Hind', 'IBM Plex Sans', system-ui, sans-serif" }}
    >
      <div className="grid w-full max-w-5xl items-center gap-10 lg:grid-cols-[1.1fr_1fr]">
        {/* Brand panel */}
        <div className="text-zinc-100">
          {onHome && (
            <button
              data-testid="auth-back-home"
              onClick={onHome}
              className="mb-6 text-sm text-zinc-400 underline-offset-4 hover:text-zinc-200 hover:underline"
            >
              ← Back to homepage
            </button>
          )}
          <div className="mb-3 text-sm font-medium uppercase tracking-[0.25em] text-rose-400">
            जिज्ञासा
          </div>
          <h1 className="mb-4 text-4xl font-semibold tracking-tight sm:text-5xl">Jigyasa</h1>
          <p className="mb-6 max-w-md text-base text-zinc-300">
            Every enquiry your business gets — captured in three fields, followed up
            on time, and never forgotten.
          </p>
          <ul className="hidden space-y-2 text-sm text-zinc-400 lg:block">
            <li>· Built for any business that runs on enquiries</li>
            <li>· Know exactly who to call back today</li>
            <li>· Your whole pipeline on one screen, on phone or desktop</li>
          </ul>
        </div>

        {/* Form card */}
        <div data-testid="auth-card" className="rounded-2xl bg-white p-6 shadow-2xl sm:p-8">
          {notice && (
            <div data-testid="auth-notice" className="mb-4 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800">
              {notice}
            </div>
          )}
          {mode === "login" && (
            <LoginForm
              onAuthed={onAuthed}
              onSignup={() => go("signup")}
              onForgot={() => go("forgot")}
              onJoin={() => go("join")}
            />
          )}
          {mode === "signup" && <SignupFlow onAuthed={onAuthed} onLogin={() => go("login")} plan={plan} />}
          {mode === "join" && <JoinFlow onAuthed={onAuthed} onBack={() => go("login")} />}
          {mode === "forgot" && (
            <ForgotPinFlow
              onDone={() => {
                setNotice("PIN changed. Log in with your new PIN.");
                setMode("login");
              }}
              onBack={() => go("login")}
            />
          )}
        </div>
      </div>
    </div>
  );
};
